module.exports = __webpack_public_path__ + "static/Ubuntu-LightItalic-d96027148c57a715e372789a90f69e8f.ttf";